function replacer(_key, value) {
    if (value instanceof Error) {
        return { message: value.message, name: value.name, stack: value.stack };
    }
    return value;
}
export function log(level, message, metadata) {
    const meta = metadata === undefined ? undefined : JSON.stringify(metadata, replacer);
    window.api.log(level, message, meta);
}
